@if (tabsAvailable.length > 0) {
<mat-tab-group
  preserveContent
  [(selectedIndex)]="activeTabIndex"
  mat-stretch-tabs="false"
>
  <mat-tab
    label="Files List"
    triggers="hover"
    ngbTooltip="View files and folders"
  >
    <ng-container *ngTemplateOutlet="storageTable"></ng-container>
  </mat-tab>
  @for (tab of tabsAvailable; track tab.filePath) {
  <mat-tab>
    <ng-template
      mat-tab-label
      triggers="hover"
      [ngbTooltip]="tab.filePath"
      placement="top left"
      container="body"
      >{{ tab.fileName }}
      <button
        class="chrome-tab-close"
        (click)="removeTab(tab); $event.stopPropagation()"
      >
        <span class="close-icon">×</span>
      </button>
    </ng-template>
    <ng-container
      *ngTemplateOutlet="
        appViewFileTemplate;
        context: {
          depName: depName,
          path: tab.filePath,
          vmNodeName: getVMNodeNameForViewFile(),
          entityType: currentEntity
        }
      "
    ></ng-container>
  </mat-tab>
  }
</mat-tab-group>
} @else {
<ng-container *ngTemplateOutlet="storageTable"></ng-container>
}

<ng-template
  #appViewFileTemplate
  let-depName="depName"
  let-path="path"
  let-vmNodeName="vmNodeName"
  let-entityType="entityType"
>
  <app-view-file
    [depName]="depName"
    [path]="path"
    [vmNodeName]="vmNodeName"
    [entityType]="entityType"
    [currentStorageName]="currentStorageName"
  >
  </app-view-file>
</ng-template>

<ng-template #storageTable>
  <div
    class="h-100 pt-1"
    cdkDropList
    (dragover)="onDragOver($event)"
    (dragenter)="onDragEnter()"
    (dragleave)="onDragLeave()"
    (drop)="onDropFromDesktop($event)"
    [class.drag-over]="isDraggedOver"
  >
    <div
      class="actionBar mt-0"
      [ngClass]="this.tempActiveProperty == 'Jobs' ? 'forStickyJobStorage' : ''"
    >
      <div class="selectActions">
        <ng-select
          *ngIf="toShow == true"
          [items]="!isVDIDep ? this.stores : ['SyncStore']"
          [clearable]="false"
          bindLabel="value"
          bindValue="value"
          placeholder="Select Store"
          (change)="sendStoreData($event)"
          [(ngModel)]="activeStore"
        >
        </ng-select>
        <ng-select
          *ngIf="toShow == true && isWorkStoreActive"
          class="ms-1"
          (change)="workNodeData($event)"
          [title]="'Switch between Nodes Workstore'"
          [(ngModel)]="workStoreNodeChoosen"
          [clearable]="false"
        >
          <ng-option title="All Nodes" value="All">All Nodes</ng-option>
          <ng-option *ngFor="let node of nodes" [value]="node.vmName">{{
            node.vmName
          }}</ng-option>
        </ng-select>
        <ng-select
          *ngIf="showSelectableStorage && !isWorkStoreActive"
          class="w-10 ms-1"
          #selectStorage
          [items]="allStorages"
          [clearable]="false"
          bindLabel="key"
          bindValue="value"
          placeholder="Select Storage"
          [formControl]="storageControl"
        >
        </ng-select>
        <div
          class="syncBreadcrumb flex-grow-1 h-100 px-2"
          [ngClass]="this.tempActiveProperty == 'Jobs' ? '' : 'mx-2'"
        >
          <b class="m-0">Files In : </b>
          <div class="d-flex flex-grow-1" *ngIf="!isBreadCrumbEditable">
            <ol
              #syncStoreBreadCrumb
              class="breadcrumb m-0 ms-2"
              *ngIf="!isBreadCrumbEditable"
            >
              <li
                class="breadcrumb-item"
                *ngFor="
                  let syncStoreCrumb of syncStoreCrumbs | storageBreadcrumb : 5
                "
                title="{{ syncStoreCrumb.path }}"
              >
                <span
                  (click)="onNavigation(syncStoreCrumb)"
                  style="cursor: pointer"
                  class="{{ syncStoreCrumb.className }}"
                  >{{ syncStoreCrumb.ui_name }}</span
                >
              </li>
            </ol>
            <p
              class="flex-grow-1 m-0"
              (click)="
                isBreadCrumbEditable = !isBreadCrumbEditable; updateBreadCrumb()
              "
            ></p>
          </div>
          <div *ngIf="isBreadCrumbEditable" class="d-flex flex-grow-1">
            <form
              action=""
              (keyup.enter)="handleSearchedPath()"
              class="d-flex w-75"
            >
              <input
                [(ngModel)]="breadCrumbPath"
                name="breadCrumbPath"
                class="flex-grow-1 ms-3 mb-0"
                style="outline: none"
                autofocus
              />
              <i
                class="bi bi-x-square ms-2 mt-1"
                style="color: var(--s-primary-color)"
                (click)="
                  isBreadCrumbEditable = false; breadCrumbPath = defaultPath
                "
              ></i>
              <i
                title="Copy current path"
                class="bi ms-2 mt-1"
                style="color: var(--s-primary-color)"
                [ngClass]="{
                  'bi-clipboard': !copiedTooltip.isOpen(),
                  'bi-clipboard-check': copiedTooltip.isOpen()
                }"
                [cdkCopyToClipboard]="breadCrumbPath"
                placement="bottom"
                triggers="hover"
                ngbTooltip="Copied"
                autoClose="outside"
                triggers="click:blur"
                #copiedTooltip="ngbTooltip"
              ></i>
              <i
                class="bi bi-arrow-right-square ms-2 mt-1"
                style="color: var(--s-primary-color)"
                (click)="handleSearchedPath()"
              ></i>
            </form>
          </div>
        </div>
      </div>

      <div class="buttonActions">
        <button
          type="button"
          [disabled]="deactivateRefresh"
          [ngStyle]="{ opacity: deactivateRefresh ? 0.5 : 1 }"
          class="actionBtn"
          container="body"
          placement="top auto"
          triggers="hover"
          ngbTooltip="Refresh current directory"
          (click)="refreshFiles()"
        >
          <span class="bi bi-arrow-clockwise"></span>
          <span class="button-animation">&nbsp;Refresh</span>
        </button>
        <ng-container *ngIf="isMonitor == false">
          <div
            class="uploadFile"
            ngbDropdown
            container="body"
            *ngIf="toShowUploadBtn"
          >
            <button
              type="button"
              class="actionBtn"
              ngbDropdownToggle
              triggers="hover"
              ngbTooltip="Select and upload files to {{ activeStore }}"
              container="body"
              placement="top auto"
            >
              <span class="bi bi-upload"></span>
              <!-- <span class="button-animation">&nbsp;Upload</span> -->
            </button>

            <div ngbDropdownMenu style="top: -6px !important">
              <button
                ngbDropdownItem
                title="Upload a new file"
                (click)="inputMultiFiles.click()"
              >
                <i class="bi bi-file-earmark"></i>
                Upload File
              </button>
              <button
                ngbDropdownItem
                title="Upload a new folder"
                (click)="selectFolder()"
              >
                <i class="bi bi-folder2"></i>
                Upload Directory
              </button>
            </div>
            <input
              type="file"
              style="display: none"
              #inputMultiFiles
              multiple
              ng2FileSelect
              [uploader]="uploader"
              (click)="inputMultiFiles.value = ''"
              (onFileSelected)="startNg2Upload($event)"
            />

            <input
              type="file"
              style="display: none"
              #inputFolder
              multiple
              webkitdirectory
              directory
              (click)="inputFolder.value = ''"
              (change)="uploadFolderFiles($event.target.files, $event)"
            />
          </div>

          <button
            type="button"
            *ngIf="isDownloadEnabled()"
            class="actionBtn"
            container="body"
            placement="top auto"
            triggers="hover"
            ngbTooltip="Download files from {{ activeStore }}"
            (click)="downloadFile()"
            [ngClass]="{ highlightButton: highlightActionButtonOnMultiSelect }"
          >
            <span class="bi bi-download"></span>
            <span class="button-animation">&nbsp;Download</span>
          </button>

          <button
            type="button"
            class="actionBtn"
            container="body"
            placement="top auto"
            triggers="hover"
            ngbTooltip="Zip Selected files/folders"
            *ngIf="toShowMultipleZip()"
            (click)="zipMultiple(content)"
            [ngClass]="{ highlightButton: highlightActionButtonOnMultiSelect }"
          >
            <span class="bi bi-file-earmark-zip"></span>
            <span class="button-animation">&nbsp;Zip</span>
          </button>

          @if(sourcePath.length == 0){
          <button
            type="button"
            class="actionBtn"
            container="body"
            placement="top auto"
            triggers="hover"
            ngbTooltip="Copy selected files/folders"
            (click)="copyMultiple()"
            [ngClass]="{ highlightButton: highlightActionButtonOnMultiSelect }"
          >
            <span class="bi bi-copy"></span>
            <span class="button-animation">&nbsp;Copy</span>
          </button>
          } @else {
          <button
            type="button"
            class="actionBtn highlightButton"
            container="body"
            placement="top auto"
            triggers="hover"
            ngbTooltip="Paste copied file in current directory."
            (click)="pasteRightClick()"
          >
            <span class="bi bi-clipboard-check"></span>
            <span class="button-animation">&nbsp;Paste</span>
          </button>
          }

          <button
            type="button"
            [hidden]="deactivateRefresh"
            [ngStyle]="{ opacity: deactivateRefresh ? 0.5 : 1 }"
            class="actionBtn"
            container="body"
            placement="top auto"
            triggers="hover"
            ngbTooltip="Delete file or folder from {{ activeStore }}"
            (click)="deleteFile()"
            [ngClass]="{ highlightButton: highlightActionButtonOnMultiSelect }"
          >
            <span class="bi bi-trash"></span>
            <span class="button-animation">&nbsp;Delete</span>
          </button>

          <div class="newDir" ngbDropdown container="body">
            <button
              type="button"
              container="body"
              class="actionBtn"
              placement="top auto"
              triggers="hover"
              ngbTooltip="Create File/Directory"
              ngbDropdownToggle
            >
              <span class="bi bi-folder-plus"></span>
              <!-- <span class="bi bi-plus-circle-fill  overlay-icon-plus"></span> -->
              <span class="button-animation">&nbsp;Create</span>
            </button>
            <div ngbDropdownMenu>
              <button
                ngbDropdownItem
                title="Create a new file"
                (click)="openFileEditor()"
              >
                <i class="bi bi-file-earmark"></i>
                Create File
              </button>
              <button
                ngbDropdownItem
                title="Create a new folder"
                (click)="openCreateDirectoryDialog()"
              >
                <i class="bi bi-folder2"></i>
                Create Directory
              </button>
            </div>
          </div>

          <button
            type="button"
            class="actionBtn"
            container="body"
            placement="top auto"
            triggers="hover"
            ngbTooltip="Toggle Logs"
            [class.highlightButton]="toBlink"
            (click)="toggleLogs()"
          >
            <span class="bi bi-list-task"></span>
          </button>
        </ng-container>
      </div>

      <div class="buttonActionDropdown">
        <button
          type="button"
          [hidden]="deactivateRefresh"
          [ngStyle]="{ opacity: deactivateRefresh ? 0.5 : 1 }"
          class="actionBtn"
          container="body"
          placement="top auto"
          triggers="hover"
          ngbTooltip="Refresh current directory"
          (click)="refreshFiles()"
        >
          <span class="bi bi-arrow-clockwise"></span>
          <span class="button-animation">&nbsp;Refresh</span>
        </button>
        <button
          type="button"
          class="actionBtn"
          container="body"
          placement="top auto"
          triggers="hover"
          ngbTooltip="Toggle Logs"
          [class.blinking-button]="toBlink"
          (click)="toggleLogs()"
        >
          <span class="bi bi-list-task"></span>
        </button>
        <div class="newDir" ngbDropdown container="body">
          <button
            type="button"
            container="body"
            class="default-btn"
            placement="auto"
            ngbDropdownToggle
          >
            Actions
            <span class="bi bi-caret-down-fill ms-1"></span>
          </button>
          <div ngbDropdownMenu>
            <!-- <button type="button" ngbDropdownItem
                [hidden]="deactivateRefresh"
                [ngStyle]="{ 'opacity': deactivateRefresh ? 0.5 : 1 }"
                container="body"
                placement="top auto" triggers="hover" ngbTooltip="Refresh current directory"
                (click)="refreshFiles()">
              <span class="bi bi-arrow-clockwise"></span>
              Refresh
            </button> -->
            <ng-container *ngIf="isMonitor == false">
              <button
                ngbDropdownItem
                triggers="hover"
                ngbTooltip="Upload a new file"
                container="body"
                placement="top auto"
                (click)="inputMultiFiles.click()"
              >
                <i class="bi bi-file-earmark"></i>
                Upload File
              </button>
              <button
                ngbDropdownItem
                triggers="hover"
                ngbTooltip="Upload a new folder"
                container="body"
                placement="top auto"
                (click)="inputFolder.click()"
              >
                <i class="bi bi-folder2"></i>
                Upload Directory
              </button>
              <input
                type="file"
                style="display: none"
                #inputMultiFiles
                multiple
                ng2FileSelect
                [uploader]="uploader"
                (click)="('')"
                (onFileSelected)="startNg2Upload($event)"
              />

              <input
                type="file"
                style="display: none"
                #inputFolder
                multiple
                webkitdirectory
                directory
                (click)="('')"
                (change)="uploadFolderFiles($event.target.files)"
              />

              <button
                type="button"
                ngbDropdownItem
                *ngIf="isDownloadEnabled()"
                container="body"
                placement="top auto"
                triggers="hover"
                ngbTooltip="Download files from {{ activeStore }}"
                (click)="downloadFile()"
              >
                <span class="bi bi-download"></span>
                Download
              </button>

              <button
                type="button"
                ngbDropdownItem
                container="body"
                placement="top auto"
                triggers="hover"
                ngbTooltip="Zip Selected files/folders"
                (click)="zipMultiple(content)"
              >
                <span class="bi bi-file-earmark-zip"></span>
                Zip
              </button>

              <button
                type="button"
                ngbDropdownItem
                container="body"
                placement="top auto"
                triggers="hover"
                ngbTooltip="Paste copied file in current directory."
                (click)="pasteRightClick()"
              >
                <span class="bi bi-clipboard-check"></span>
                <span class="button-animation">&nbsp;Paste</span>
              </button>

              <button
                type="button"
                ngbDropdownItem
                [hidden]="deactivateRefresh"
                [ngStyle]="{ opacity: deactivateRefresh ? 0.5 : 1 }"
                container="body"
                placement="top auto"
                triggers="hover"
                ngbTooltip="Delete file or folder from {{ activeStore }}"
                (click)="deleteFile()"
              >
                <span class="bi bi-trash"></span>
                Delete
              </button>

              <!-- <button type="button" ngbDropdownItem
                      container="body"
                      placement="top auto" triggers="hover" ngbTooltip="Toggle Logs"
                      [class.blinking-button]="toBlink"
                      (click)="toggleLogs()">
                <span class="bi bi-list-task"></span>
                Logs
              </button> -->

              <button
                ngbDropdownItem
                triggers="hover"
                ngbTooltip="Create a new file"
                container="body"
                placement="top auto"
                triggers="hover"
                ngbTooltip="Create new file"
                (click)="openFileEditor()"
              >
                <i class="bi bi-file-earmark"></i>
                Create File
              </button>
              <button
                ngbDropdownItem
                triggers="hover"
                ngbTooltip="Create a new folder"
                container="body"
                placement="top auto"
                (click)="openCreateDirectoryDialog()"
              >
                <i class="bi bi-folder2"></i>
                Create Directory
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="drag-overlay" *ngIf="isDraggedOver">
      <div class="drag-overlay-content">
        <!-- Add your desired UI feedback here, such as a message or icon -->
        Drag and drop your files here
      </div>
    </div>

    <div
      class="d-flex flex-column position-relative"
      style="height: calc(100% - 3rem) !important"
    >
      <div
        [ngClass]="
          (this.tempActiveProperty == 'Jobs'
            ? 'storageJobsTable'
            : 'storageTable') +
          ' ' +
          (toShowLogs ? 'h-75' : 'h-100')
        "
      >
        <table class="table" style="table-layout: fixed">
          <thead>
            <tr class="synchpc-th table-list-head">
              <th
                class="selectAllCheckBox text-center"
                title="Select All"
                style="width: 3%"
                (change)="onSelectAllCheckBox($event.target.checked)"
              >
                <input type="checkbox" [checked]="selectAll" id="" />
              </th>
              <th scope="col" style="width: 53%">
                <span
                  style="cursor: pointer; user-select: none"
                  (click)="sortByName()"
                  title="Sort Alphabetically"
                >
                  Name
                  <span
                    [ngClass]="
                      fileNameSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                    "
                    class="bi"
                  ></span>
                </span>
                <input
                  *ngIf="syncStoreItems"
                  class="storageSearch"
                  type="search"
                  placeholder="Search..."
                  title="Search files/folders in current path."
                  [formControl]="filterSearch"
                />
                <span
                  class="storageSearchCancel bi bi-x-lg text-danger"
                  *ngIf="storageSearch"
                  (click)="resetStorageSearch()"
                ></span>
                <span class="m-0 ms-4 w-25" *ngIf="multiSelectIndex?.length > 0"
                  >({{ multiSelectIndex.length }}) Selected</span
                >
              </th>
              <th scope="col" style="width: 14%">
                <span
                  style="cursor: pointer; user-select: none"
                  (click)="sortByOwner()"
                  title="Sort Alphabetically"
                >
                  Owner
                  <span
                    [ngClass]="
                      ownerSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                    "
                    class="bi"
                  ></span>
                </span>
              </th>
              <th scope="col" style="width: 10%">Size</th>
              <th scope="col" style="width: 20%">
                <span
                  style="cursor: pointer; user-select: none"
                  (click)="sortByTime()"
                  title="Sort Ascending/Descending"
                >
                  Last Modified
                  <span
                    [ngClass]="
                      lastModifiedSort
                        ? 'bi-arrow-up-short'
                        : 'bi-arrow-down-short'
                    "
                    class="bi"
                  ></span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="filterItems && filterItems.length; else noDataOrError">
            <tr
              class="table-list-row"
              *ngFor="
                let syncStoreItem of filterItems
                  | paginate
                    : {
                        itemsPerPage: config.itemsPerPage,
                        currentPage: config.currentPage,
                        id: 'storage_pagination'
                      };
                let i = index
              "
              [ngClass]="{
                highlightClickedRow: checkIfExistsInSelectedItems(syncStoreItem)
              }"
              (click)="activateClass(syncStoreItem)"
              (dblclick)="onNavigation($event, syncStoreItem, i)"
              [cdkContextMenuTriggerFor]="contextMenu"
              [cdkContextMenuTriggerData]="{ $implicit: syncStoreItem }"
              [cdkContextMenuDisabled]="multiSelectIndex.length > 1"
              (contextmenu)="onFileRightClick(syncStoreItem, $event)"
            >
              <!-- [contextMenu]="basicMenu" (contextmenu)="onFileRightClick(syncStoreItem)" [contextMenuSubject]="syncStoreItem" -->
              <td scope="row" class="text-center">
                <input
                  type="checkbox"
                  title="Select File"
                  class="selectCheckbox"
                  [checked]="checkIfExistsInSelectedItems(syncStoreItem)"
                  (change)="handleCheckboxSelection(i)"
                />
              </td>
              <td
                onclick="return false;"
                id="{{ i }}"
                title="{{ syncStoreItem?.name }}"
                attr.data-directory-path="{{ syncStoreItem.path }}"
              >
                <p class="ellipsisText">
                  <span
                    class="bi typeIcons"
                    [ngClass]="
                      syncStoreItem.type == 'file'
                        ? 'bi-file-earmark'
                        : 'bi-folder-fill'
                    "
                  ></span>
                  &nbsp;{{ syncStoreItem?.name }}
                </p>
              </td>
              <td>{{ syncStoreItem.owner || "NA" }}</td>
              <td (contextmenu)="onRightClick()">
                {{
                  convertFileSize(syncStoreItem) != "0 bytes"
                    ? convertFileSize(syncStoreItem)
                    : "NA"
                }}
              </td>
              <td
                (contextmenu)="onRightClick()"
                [title]="
                  !syncStoreItem?.date || syncStoreItem?.date == 'NA'
                    ? 'NA'
                    : (syncStoreItem?.date | date : 'medium')
                "
              >
                <p class="ellipsisText">
                  {{
                    !syncStoreItem?.date || syncStoreItem?.date == "NA"
                      ? "NA"
                      : (syncStoreItem?.date | date : "medium")
                  }}
                </p>
              </td>
            </tr>
          </tbody>
          <ng-template #noDataOrError>
            <tr class="table-list-row">
              <td style="padding-top: 6rem" colspan="5">
                <div class="accessDenied">
                  <p>{{ errorMsg }}</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </table>
      </div>
      <pagination-controls
        id="storage_pagination"
        *ngIf="filterItems && filterItems.length > config.itemsPerPage"
        autoHide="true"
        class="my-pagination text-center mb-0"
        style="padding-top: 0.2rem"
        (pageChange)="config.currentPage = $event"
        (pageBoundsCorrection)="config.currentPage = $event"
      >
      </pagination-controls>

      <div class="logs h-25" *ngIf="toShowLogs" #scrollMe>
        <button
          type="button"
          *ngIf="StorageLogsData?.length != 0 && isMonitor == false"
          class="default-btn clearLogBtn"
          (click)="clearLogs()"
          title="Clear all completed logs"
        >
          Clear Logs
        </button>
        <span
          style="max-width: 80%; z-index: 2"
          class="d-flex"
          *ngFor="let log of StorageLogsData"
          [title]="log.message"
          ><p class="ellipsisText" style="max-width: 75%">{{ log.message }}</p>

          <a
            *ngIf="log.status.startsWith('http')"
            [href]="log.status"
            target="_blank"
            style="color: var(--s-primary-color); text-decoration: underline"
          >
            {{ log.status }}
          </a>

          <span
            *ngIf="!log.status.startsWith('http')"
            [ngStyle]="{ color: isStatusRed(log.status) ? 'red' : 'green' }"
            >{{ log.status }}</span
          >
          <span *ngIf="log.timeRemaining != null">
            - Time remaining:
            <label [ngStyle]="{ color: log.logType == 1 ? 'green' : 'red' }">{{
              log.timeRemaining | timeRemaining
            }}</label></span
          >
          <a
            *ngIf="log.showLogActions && log.isRequestCompleted == false"
            [title]="getOperationName(log.logType)"
            style="
              margin-left: 5px;
              color: var(--s-primary-color);
              cursor: pointer;
            "
            (click)="cancelOperation(log)"
            >Cancel</a
          >
          <br
        /></span>
        <div *ngIf="StorageLogsData?.length == 0" class="noLogsAvailable">
          <p>No Logs Available</p>
        </div>
      </div>

      <ngx-spinner
        bdColor="rgba(0,0,0,0)"
        size="default"
        zIndex="1"
        color="var(--s-primary-color)"
        type="ball-spin"
        [fullScreen]="false"
        name="storageLoad"
      ></ngx-spinner>
    </div>

    <ng-template #contextMenu #menu let-item>
      <div class="storage-menu" cdkMenu [hidden]="isMonitor">
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="onNavigation(null, item, 0)"
          [hidden]="toDisableOpen(item)"
        >
          Open
        </button>
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="showFileData(item)"
          [hidden]="!toshowViewFile(item)"
        >
          View File
        </button>
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="editItem(item)"
          [hidden]="toDisableEditRightClick(item)"
        >
          Edit File
        </button>
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="copyRightClick(item)"
          [hidden]="toDisableCopyRightClick(item)"
        >
          Copy
        </button>
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="pasteRightClick(item)"
          [hidden]="toDisablePasteRightClick(item)"
        >
          Paste
        </button>
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="copyDownloadURL()"
          [hidden]="toDisableCopyDownloadUrlRightClick(item)"
        >
          Copy Download URL
        </button>
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="downloadFileRightClick(item)"
          [hidden]="toDisableDownloadRightClick(item)"
        >
          Download
        </button>
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="deleteFileRightClick(item)"
          [hidden]="isMonitor"
        >
          Delete
        </button>
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="renameRightClick(item)"
          [hidden]="toDisableRename(item)"
        >
          Rename
        </button>
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="zipUnzipData([item], true)"
          [hidden]="!toShowZip(item)"
        >
          Zip
        </button>
        <button
          class="storage-menu-item"
          cdkMenuItem
          (click)="zipUnzipData([item], false)"
          [hidden]="!toShowUnZip(item)"
        >
          Unzip
        </button>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Zip File Name</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>
  <div class="modal-body">
    <form>
      <div class="mb-3">
        <h3>Files/Folders to be Zipped:</h3>
        <p class="zip-file-names">{{ zipFileNames }}</p>
        <br />
        <div class="form-group">
          <label for="zipFileName">Enter the Zip File Name:</label>
          <input
            id="zipFileName"
            class="form-control"
            placeholder="Example: myFiles"
            autocomplete="off"
            name="zipFileName"
            #zipFileName
            required
          />
          <small class="form-text text-muted"
            >Please provide a unique and descriptive name for the zip
            file.</small
          >
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      [hidden]="zipFileName.value == ''"
      (click)="modal.close(zipFileName.value)"
    >
      Submit
    </button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      Cancel
    </button>
  </div>
</ng-template>
